import {AfriexBlockReason} from '@afriex/core/domain/enums';

export {
  AfriexBlockReason,
  AfriexUnblockReason,
} from '@afriex/core/domain/enums';

export const nonBlockingReasons = [
  AfriexBlockReason.DO_NOT_ISSUE_VIRTUAL_ACCOUNT,
];
